<script setup lang="ts">
import { Ban, HandCoins, History, Undo2 } from 'lucide-vue-next'
import { Button } from 'pejer/src/components/ui/button'
import {
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from 'pejer/src/components/ui/dropdown-menu'
import { computed } from 'vue'
import CancelInvoiceModal from './CancelInvoiceModal.vue'
import HistoryModal from './HistoryModal.vue'
import RegisterPaymentModal from './RegisterPaymentModal.vue'
import RegisterRefundModal from './RegisterRefundModal.vue'
import { ClubAccountItem, isUnpaid } from './types'

const props = defineProps<{
  item: ClubAccountItem
}>()

const canRegisterPayment = computed(() => isUnpaid(props.item))
const canRegisterRefund = computed(
  () =>
    props.item.paidKroner > 0 &&
    (isUnpaid(props.item) || props.item.paymentStatus === 'ChargedPayment')
)
const canCancel = computed(() => isUnpaid(props.item) && props.item.paidKroner === 0)
const hasHistory = computed(
  () =>
    props.item.paidKroner > 0 ||
    props.item.paymentStatus === 'ChargedPayment' ||
    props.item.paymentStatus === 'RefundedPayment'
)
</script>
<template>
  <template v-if="canRegisterPayment || canRegisterRefund || canCancel || hasHistory">
    <DropdownMenuSeparator />
    <DropdownMenuLabel class="text-xs text-muted-foreground font-normal">
      Klubbens konto
    </DropdownMenuLabel>
    <DropdownMenuGroup class="font-semibold">
      <DropdownMenuItem v-if="canRegisterPayment" class="p-0">
        <RegisterPaymentModal :item="item">
          <Button
            @click.prevent.stop
            class="w-full gap-2 flex flex-nowrap justify-start"
            variant="ghost"
          >
            <HandCoins class="w-4 h-4" />Registrer innbetaling
          </Button>
        </RegisterPaymentModal>
      </DropdownMenuItem>
      <DropdownMenuItem v-if="canRegisterRefund" class="p-0">
        <RegisterRefundModal :item="item">
          <Button
            @click.prevent.stop
            class="w-full gap-2 flex flex-nowrap justify-start"
            variant="ghost"
          >
            <Undo2 class="w-4 h-4" />Registrer tilbakebetaling
          </Button>
        </RegisterRefundModal>
      </DropdownMenuItem>
      <DropdownMenuItem v-if="hasHistory" class="p-0">
        <HistoryModal :item="item">
          <Button
            @click.prevent.stop
            class="w-full gap-2 flex flex-nowrap justify-start"
            variant="ghost"
          >
            <History class="w-4 h-4" />Vis historikk
          </Button>
        </HistoryModal>
      </DropdownMenuItem>
      <DropdownMenuItem v-if="canCancel" class="p-0">
        <CancelInvoiceModal :item="item">
          <Button
            @click.prevent.stop
            class="w-full gap-2 flex flex-nowrap justify-start text-red-600"
            variant="ghost"
          >
            <Ban class="w-4 h-4" />Kanseller faktura
          </Button>
        </CancelInvoiceModal>
      </DropdownMenuItem>
    </DropdownMenuGroup>
  </template>
</template>
